import React, { useEffect, useState } from 'react';

import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Sidebar from '../layout/Sidebar';
import Config from '../actions/Config';

import '../../scss/resources.scss';


function Resources(props) {
    const BASE_URL = Config();

    return (
        <div className='resources-container'>
            <Header />
            <div className='row resources-section'>
                <Sidebar />
                <div className='col-10 resources-section-right'>
                    <iframe id="previewiFrame" className='htmlcontent' src={`${BASE_URL}/resources/pages/index.html`} style={{width: "100%", height: "100%", display: "block", overflow: "hidden"}}></iframe>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Resources;